export function goBack(element: HTMLElement): void {
  // Check if previous page is same domain
  if (document.referrer.indexOf(window.location.host) !== -1) {
    // Add event if it is otherwise allow link click to go to arcgive
    element.addEventListener('click', (e) => {
      e.preventDefault();
      history.back();
    })
  }
}